export default __webpack_public_path__ + "images/icons/arrow-top-selected-f965e6ed63b738698937c831fa24086f.svg";